// Kept in localStorage rather than the URL: the login link sent by email opens a new tab.
const KEY = 'login.next'

/** A same-origin path, so that a crafted login link cannot redirect elsewhere. */
export function safeNext(value: string | null | undefined): string | undefined {
  return value && /^\/(?![/\\])/.test(value) ? value : undefined
}

/** Remembers where to go after logging in; forgets it when `path` is not a safe path. */
export function rememberNext(path: string | null | undefined) {
  const next = safeNext(path)
  try {
    if (next) localStorage.setItem(KEY, next)
    else localStorage.removeItem(KEY)
  } catch {
    // Storage blocked: the user lands on the home page instead
  }
}

/** The page to open after logging in, `/` by default. */
export function takeNext(): string {
  try {
    const next = safeNext(localStorage.getItem(KEY))
    localStorage.removeItem(KEY)
    return next ?? '/'
  } catch {
    return '/'
  }
}

export const loginUrl = (next: string) => `/login?next=${encodeURIComponent(next)}`
